import { getNoticeList } from '@/api/servico';
// import ImageNotificationBellIcon from '@/assets/images/poster/xiaoxi.svg';
import xiaoxi from '@/assets/images/home/xiaoxi.png';
import { useJumpLink } from '@/utils/hooks';
import { NoticeBar, Swiper } from 'antd-mobile';
import { useEffect, useState, memo, FC } from 'react';
import './swiper.less';

interface QueryNoticeItem {
  content: string;
}

interface BigBannerItem {
  id: string;
  url: string;
  remark: string;
}

type QueryNoticeList = QueryNoticeItem[];
type BigBannerList = BigBannerItem[];

const EMPTY_STRING = '';

// 每个组件都会用到各自的传入的属性，因此统一名称为 Props
interface Props {
  allBannerList: {
    bigBannerList: BigBannerList;
  };
}

const BannerNotice: FC<Props> = ({ allBannerList }) => {
  const { bigBannerList = [] } = allBannerList;
  const [noticeContent, setNoticeContent] = useState(EMPTY_STRING);
  const [handlJumpLink] = useJumpLink();

  // 获取轮播消息
  const queryNoticeList = async () => {
    const { code, data: queryNoticeList } = await getNoticeList();

    if (code !== 200 || queryNoticeList.length <= 0) {
      return;
    }

    const str = (queryNoticeList as QueryNoticeList)
      .map((item, index) => `${index + 1}: ${item.content}    `)
      .join(EMPTY_STRING);

    setNoticeContent(str);
  };

  const renderBigBannerList = (bigBannerList: BigBannerList) => {
    return (
      <Swiper loop autoplay indicatorProps={{ color: 'white' }}>
        {bigBannerList.map(item => (
          <Swiper.Item key={item.id}>
            <div className="content">
              <img
                src={item.url}
                onClick={() => handlJumpLink(item)}
                alt={item.remark}
              />
            </div>
          </Swiper.Item>
        ))}
      </Swiper>
    );
  };

  const renderNoticeContent = (noticeContent: string) => {
    return (
      <div className="top-noty-bar-frame">
        <div className="ico">
          <img src={xiaoxi} alt="notification-bell-icon" />
        </div>
        <div className="txt">
          <NoticeBar
            content={noticeContent}
            color="alert"
            icon=""
            style={{
              '--background-color': '#161d16',
              '--border-color': 'none',
              '--text-color': '#fff'
            }}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    queryNoticeList();
  }, []);

  return (
    <>
      {bigBannerList.length !== 0 && renderBigBannerList(bigBannerList)}
      {noticeContent && renderNoticeContent(noticeContent)}
    </>
  );
};

const MemoBannerNotice = memo(BannerNotice);
export default MemoBannerNotice;
